import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["px-4 py-2 rounded-lg bg-primary-600 hover:bg-primary-800 text-white font-bold mx-auto", {'uppercase': _ctx.uppercase}])
  }, _toDisplayString(_ctx.text), 3))
}